import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getDarts } from '~/api';
import dartKey from './dartKey';
import useDartCache from './useDartCache';

const useDecreaseDartMutation = () => {
  const queryClient = useQueryClient();
  const queryKey = dartKey.getDarts();

  const { decreaseDartInCache } = useDartCache();

  return useMutation({
    mutationFn: getDarts,
    onMutate: async () => {
      const previousDarts = queryClient.getQueryData<number>(queryKey);
      if (typeof previousDarts === 'number' && previousDarts > 0) {
        queryClient.setQueryData<number>(queryKey, previousDarts - 1);
      }
      return { previousDarts };
    },
    onSuccess: ({ data, status }) => {
      decreaseDartInCache();
    },
    onError: (error, variables, context) => {
      console.error(error);
      if (context?.previousDarts !== undefined) {
        queryClient.setQueryData(queryKey, context.previousDarts);
        queryClient.invalidateQueries({ queryKey });
      }
    },
  });
};

export default useDecreaseDartMutation;
